import {
  APPLY_TO_ALL_CURRENCIES,
  SHIPPING_ALL_VALUE,
} from '@/@types/ShippingConfigurations';
import { normalizeCountryToAlpha2 } from '@/utils/shippingCountries';
import ShippingListCell, { ShippingListItem } from './ShippingListCell';

type ShippingStringListCellProps = {
  values: string[];
  modalTitle: string;
  allLabel?: string;
  formatLabel?: (value: string) => string;
  showCountryFlags?: boolean;
  allWildcards?: string[];
};

function toListItems(
  values: string[],
  formatLabel: (value: string) => string,
  showCountryFlags?: boolean,
): ShippingListItem[] {
  return values.map((value) => ({
    id: value,
    label: formatLabel(value),
    ...(showCountryFlags
      ? { countryCode: normalizeCountryToAlpha2(value) }
      : {}),
  }));
}

export default function ShippingStringListCell({
  values,
  modalTitle,
  allLabel,
  formatLabel = (value) => value,
  showCountryFlags = false,
  allWildcards = [SHIPPING_ALL_VALUE, APPLY_TO_ALL_CURRENCIES],
}: ShippingStringListCellProps) {
  const isAll = values.some((value) => allWildcards.includes(value));

  return (
    <ShippingListCell
      items={toListItems(values, formatLabel, showCountryFlags)}
      modalTitle={modalTitle}
      allLabel={allLabel}
      isAll={isAll}
      showCountryFlags={showCountryFlags}
    />
  );
}
